import React from 'react';

const PA = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_74"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_74)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.974 4.974C5.908 5.57 5.72 6 5.5 6C5.28 6 5.092 5.57 5.026 4.974C4.43 4.908 4 4.72 4 4.5C4 4.28 4.43 4.092 5.026 4.026C5.092 3.43 5.28 3 5.5 3C5.72 3 5.908 3.43 5.974 4.026C6.57 4.092 7 4.28 7 4.5C7 4.72 6.57 4.908 5.974 4.974Z"
        fill="#005095"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.974 11.974C15.908 12.57 15.72 13 15.5 13C15.28 13 15.092 12.57 15.026 11.974C14.43 11.908 14 11.72 14 11.5C14 11.28 14.43 11.092 15.026 11.026C15.092 10.43 15.279 10 15.5 10C15.72 10 15.908 10.43 15.974 11.026C16.57 11.092 17 11.279 17 11.5C17 11.72 16.57 11.908 15.974 11.974Z"
        fill="#D4062E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8H10V15H0V8Z"
        fill="#005095"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0H21V8H10V0Z"
        fill="#D4062E"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default PA;
